import { prepareBuilderArtwork } from "./artwork";
import { builderSessionId, useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { useHistoryStore } from "../../stores/history-store";

export async function uploadBuilderArtwork(files: File[]) {
  if (!files.length || useMetadataBuilderStore.getState().uploading) return;
  useMetadataBuilderStore.setState({ uploading: true, uploadIssues: [] });
  try {
    const result = await prepareBuilderArtwork(files);
    useMetadataBuilderStore.setState({ uploadIssues: result.issues });
    if (!result.artwork) return;
    // The upload may finish after leaving builder mode; always target its own session.
    useHistoryStore.getState().appendMetadata(builderSessionId, {
      type: "artwork/set", artwork: result.artwork,
      id: crypto.randomUUID(), at: Date.now(),
    });
  } catch {
    useMetadataBuilderStore.setState({ uploadIssues: [{ code: "normalize", file: files.map(file => file.name).join(", ") }] });
  } finally {
    useMetadataBuilderStore.setState({ uploading: false });
  }
}
